/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_tabs = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function (

	) {

		/**
		 * Get: Click on tab
		 */
		$(document).on('click', '.js-tab-item', function () {
			specific_tabs.setActive(
				$(this),
				'tab'
			);
		});
		$(document).on('click', '.js-tab-item-2', function () {
			specific_tabs.setActive(
				$(this),
				'tab'
			);
		});

		/**
		 * Get: Selector change
		 */
		$(document).on('change', '.js-media-select', function () {
			specific_tabs.setActive(
				$(this),
				'select'
			);
		});
		$(document).on('change', '.js-omgeving-select', function () {
			specific_tabs.setActive(
				$(this),
				'select'
			);
		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.setActive = function (
		_this,
		_tab_or_select
	) {

		/**
		 * Tabs
		 */
		if (
			_tab_or_select == 'tab'
		) {
			/**
			 * Get the INT after second - in classname
			 */
			var _number = _this.attr('class').split('js-tab-item-')[1];
			if (_number) {
				_number = '-' + _number;
			} else {
				_number = '';
			}

			/**
			 * Set all inactive
			 */
			$('.js-tab-item' + _number).removeClass('active');
			$('.js-tab-pane' + _number).removeClass('active');

			/**
			 * Set: Clicked tab active
			 */
			_this.addClass('active');

			var tab = _this.data('tab');
			$('.js-tab-pane' + _number + '[data-tab="' + tab + '"]').addClass('active');

		} else {

			/**
			 * Check it _this has js-tab-pane or js-tab-pane-2
			 */
			var has_number = '';
			if (
				_this.hasClass('js-omgeving-select')
			) {
				has_number = '-2';
			} else {
				has_number = '';
			}

			/**
			 * Get: Selected data-tab
			 */
			var tab_selector = _this.find('option:selected').data('tab');

			/**
			 * Set all inactive
			 */
			$('.js-tab-pane' + has_number).removeClass('active');
			/**
			 * Set: Selected tab active
			 */
			$('.js-tab-pane' + has_number + '[data-tab="' + tab_selector + '"]').addClass('active');
		}

	};

}).apply(specific_tabs);